/** «Пришли сегодня» + «Сегодня работают» над лентой отчётов ОО (24.08, владелец).
 *  Пришли: брони, созданные в выбранный день — КВЕСТ дата время · бейдж игроков · ₽оценка
 *  (минимум прайса / формула по игрокам / факт) первой строкой, источник и канал
 *  связи (с чекером) второй. Работают: имя + квесты расстановки с временем +
 *  допработы — чисто справочный блок, НЕкликабельный (24.08, владелец). */
import { useEffect, useState } from "react";
import { api } from "../../api/client";
import { PlayersBadge } from "../../components/shared";
import { isNightSlot, addDays, parseDateApi, fmtDateApi } from "../../utils/date";
import type { OoGameSummary, OoDayBrief } from "../../hooks/useOoReports";
import css from "./dashboard.module.css";

/** Ростер операторов для «Сегодня не работают» — тот же фильтр, что в расстановке. */
interface RosterStaff { name?: string; role?: string; status?: string; custom_perms?: string }
const isOp = (s: RosterStaff) => s.status === "active"
  && (s.role === "operator" || (s.custom_perms ?? "").includes("operator") || s.role === "oo" || s.role === "dc");

const fmtR = (n: number): string => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
const CH: Record<string, string> = { tg: "✈", vk: "VK", max: "MAX" };
const ACT_ICO: Record<string, string> = { cancelled_booking: "🔴", moved_booking: "🔀", forced_moved: "🔀", restored_booking: "🔄", forced_restored: "🔄", archived_booking: "🗑", deleted_lead: "✕" };
const dm = (iso: string): string => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}` : "");
/** 03.09: ночной слот (до 06:00) хранится СЛЕДУЮЩИМ календарным днём — модалке нужен день сетки */
const gridDay = (iso: string, time: string): string => (iso && isNightSlot(time) ? fmtDateApi(addDays(parseDateApi(iso), -1)) : iso);
/** Enter/Space на псевдокнопках — как клик */
const keyAct = (fn?: () => void) => fn ? (e: { key: string; preventDefault: () => void }) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fn(); } } : undefined;
/** Привязанный TG-аккаунт для показа рядом с ✈ (26.08, владелец): @ник или id. */
const tgAcc = (channel: string | null, tg: string | null): string => {
  const v = (tg ?? "").trim();
  if ((channel ?? "").trim() !== "tg" || !v || v === "[encrypted]") return "";
  return /^\d+$/.test(v) ? `id${v}` : `@${v.replace(/^@/, "")}`;
};

export function DayBrief({ brief, games, dcDuty, onOpenBooking }: {
  brief: OoDayBrief; games: OoGameSummary[]; dcDuty?: string | null;
  /** 03.09 (владелец): тап по квесту/дате/времени/источнику — оригинальная модалка «Изменение брони» */
  onOpenBooking?: (id: number, date: string) => void;
}) {
  const [roster, setRoster] = useState<string[]>([]);
  /* 03.09 (владелец): раскрытое действие DC — краткая история брони под строкой */
  const [openAct, setOpenAct] = useState<number | null>(null);
  useEffect(() => { setOpenAct(null); }, [brief]); /* другой день/обновление — раскрытие сбрасываем */
  useEffect(() => {
    let alive = true;
    api<{ results?: RosterStaff[] }>("/api/staff").then((r) => { if (alive) setRoster((r.results ?? []).filter(isOp).map((s) => s.name ?? "").filter(Boolean)); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  /* «Сегодня работают»: оператор → квесты расстановки + допработы + админство
     (фуксией). Времена одного квеста сливаются под одним именем:
     «ТАРО 16:00 · 20:30» (26.08, владелец). */
  const busy = new Map<string, { acts: string[]; adm: string[] }>();
  const row = (name: string) => { const v = busy.get(name) ?? { acts: [], adm: [] }; busy.set(name, v); return v; };
  const grp = new Map<string, Map<string, string[]>>();
  for (const g of games) for (const r of g.operatorRows) {
    const m = grp.get(r.name) ?? new Map<string, string[]>();
    m.set(g.questShort, [...(m.get(g.questShort) ?? []), g.time]); grp.set(r.name, m);
  }
  for (const [name, m] of grp) row(name).acts.push(...[...m.entries()].map(([q, ts]) => `${q} ${ts.join(" · ")}`));
  for (const e of brief.extrawork) row(e.operator).acts.push(`доп ${e.timeFrom}–${e.timeTo}${e.description ? ` ${e.description.slice(0, 18)}` : ""}`);
  for (const h of brief.halladmins) row(h.operator).adm.push(`адм ${h.branch.toUpperCase()}${h.timeFrom && h.timeTo ? ` ${h.timeFrom}–${h.timeTo}` : ""}`);
  const crew = [...busy.entries()];
  /* 02.09 (владелец): день без игр и допработ — нарезка экрана та же, блоки
     остаются с нулями/«никто», а не исчезают */
  return (
    <section className={css.brief}>
      <div className={css.briefCols}>
        <div className={css.briefMain}>
          {/* 26.08 (владелец): в счёте ТОЛЬКО реальные брони; чекер связи убран; 🍵 = чайная */}
          {/* 03.09 (владелец): «DC: имя · N броней · ₽» одной строкой, «Пришли сегодня» — другой */}
          <div className={`${css.briefRow} ${css.briefHead}`}>
            {dcDuty ? <span className={css.briefDc} title="Дежурный на DC — кто привёл эти брони">DC: <b>{dcDuty}</b></span> : null}
            <span className={css.briefStat}><b>{brief.total}</b> брон. · ~<b>₽{fmtR(brief.revenue)}</b></span>
          </div>
          <div className={css.briefRow}>
            <span className={css.briefLbl}>Пришли сегодня</span>
          </div>
          {brief.rows.map((b) => {
            /* отменённая/убранная бронь в сетке дня не живёт — модалку по ней не открыть */
            const open = onOpenBooking && b.status === "active" ? () => onOpenBooking(b.id, gridDay(b.date, b.time)) : undefined;
            return (
            <div key={b.id} className={`${css.briefItem} ${b.status === "cancelled" ? css.briefCancelled : ""} ${b.type === "lead" ? css.briefDim : ""}`}>
              <div className={css.briefIssue}>
                {/* 27.08 (владелец): зелёный = предоплата есть, оранжевый = нет.
                    03.09: квест/дата/время — тап открывает оригинальную модалку брони */}
                <span className={`${css.briefOpen} ${open ? css.briefClick : ""}`} role={open ? "button" : undefined} tabIndex={open ? 0 : undefined}
                  title={open ? "Открыть бронь" : undefined} onClick={open} onKeyDown={keyAct(open)}>
                  <span className={`${css.briefQuest} ${b.prepaid ? css.bqPre : css.bqNoPre}`}>{b.quest}</span>
                  <span className={css.briefDate}>{dm(b.date)}</span>
                  <span className={css.briefTime}>{b.time}</span>
                </span>
                {/* 05.09 (владелец): стандартный бейдж игроков; карточка — только по живой брони (отмена/лид — индикатор) */}
                {b.players ? <PlayersBadge count={b.players} bookingId={b.status === "active" ? b.id : undefined} size="sm" /> : null}
                {b.tea ? <span title="Чайная">🍵</span> : null}
                {b.type === "lead" ? <span className={css.briefLead}>лид</span> : null}
                <span className={css.briefSum}>₽{fmtR(b.sum)}</span>
              </div>
              {/* вторая строка — доп. зона тапа той же брони; для клавиатуры кнопка одна (выше) */}
              <div className={`${css.briefSub} ${open ? css.briefClick : ""}`} title={open ? "Открыть бронь" : undefined} onClick={open}>
                {b.source ? <span className={css.briefSrc}>{b.source}</span> : <span className={css.briefSrc}>источник?</span>}
                {(b.channel ?? "").trim() ? <span className={css.briefCh}>{CH[(b.channel ?? "").trim()] ?? b.channel}</span> : null}
                {tgAcc(b.channel, b.telegram) ? <span className={css.briefTgAcc}>{tgAcc(b.channel, b.telegram)}</span> : null}
              </div>
            </div>
            );
          })}
          {/* действия ДК за день: отмены, переносы, восстановления (26.08, владелец) */}
          {brief.dcactions.length ? (
            <>
              <div className={`${css.briefRow} ${css.briefActsHead}`}>
                <span className={css.briefLbl}>Действия DC</span>
                <span className={css.briefStat}><b>{brief.dcactions.length}</b></span>
              </div>
              {brief.dcactions.map((a, i) => {
                const can = !!a.info; const open = openAct === i;
                const first = (n: string) => n.split(" ")[0] ?? n;
                return (
                  <div key={a.bookingId ? `${a.bookingId}_${i}` : i}>
                    <div className={`${css.briefAct} ${can ? css.briefClick : ""} ${open ? css.briefActOpen : ""}`} role={can ? "button" : undefined} tabIndex={can ? 0 : undefined} aria-expanded={can ? open : undefined}
                      title={can ? "Кто бронировал, кто был DC, кто менял" : undefined} onClick={() => { if (can) setOpenAct(open ? null : i); }} onKeyDown={keyAct(can ? () => setOpenAct(open ? null : i) : undefined)}>
                      <span className={css.briefActIco}>{ACT_ICO[a.action] ?? "•"}</span> {a.at ? `${a.at} ` : ""}{a.label}
                      {a.reason ? <span className={css.briefActBy}> ({a.reason})</span> : null}
                      {a.staff ? <span className={css.briefActBy}> — {first(a.staff)}</span> : null}
                    </div>
                    {open && a.info ? (
                      <div className={css.briefActPop}>
                        <div>Забронировал(а): <b>{a.info.createdBy || "?"}</b>{a.info.createdAt ? <span className={css.briefActBy}> · {a.info.createdAt}</span> : null}</div>
                        {a.info.dcName && a.info.dcName !== a.info.createdBy ? <div>DC в тот день: <b>{a.info.dcName}</b></div> : null}
                        {a.info.editors.length ? <div>Изменяли: <b>{a.info.editors.join(", ")}</b></div> : null}
                        {/* ссылка только если бронь СЕЙЧАС живёт в сетке (перенесённую могли потом отменить) */}
                        {a.bookingId && a.bookingDate && onOpenBooking && a.bookingStatus === "active" ? (
                          <button type="button" className={css.briefActLink} onClick={() => onOpenBooking(a.bookingId!, gridDay(a.bookingDate!, a.bookingTime ?? ""))}>Открыть бронь ›</button>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </>
          ) : null}
        </div>
        <div className={css.briefSide}>
            <div className={css.briefLbl}>Сегодня работают</div>
            {!crew.length ? <div className={`${css.briefWho} ${css.briefDim}`}>никто</div> : null}
            {crew.map(([name, v]) => (
              <div key={name} className={css.briefWho}>
                <b>{name.split(" ")[0]}</b> {v.acts.join(" · ")}
                {v.adm.length ? <span className={css.briefAdm}>{v.acts.length ? " · " : ""}{v.adm.join(" · ")}</span> : null}
              </div>
            ))}
            {/* свободные операторы дня (26.08, владелец) */}
            {(() => { const free = roster.filter((n) => !busy.has(n)); return free.length ? (
              <>
                <div className={`${css.briefLbl} ${css.briefFreeLbl}`}>Сегодня не работают</div>
                {/* 28.08 (владелец): имя ЦЕЛИКОМ и неразрывно — «Даша А» резалась
                    до «Даша» и путалась с работающей Дашей */}
                <div className={css.briefFree}>{free.map((n) => n.replace(/ /g, " ")).join(", ")}</div>
              </>
            ) : null; })()}
        </div>
      </div>
    </section>
  );
}
